import React from "react";

function BlockGameDevHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-8 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Blockchain Game Development Company
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    At Xeer, our blockchain developers and game designers create
                    optimized, gamified blockchain solutions that enhance
                    gameplay without sacrificing performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockGameDevHero;
